<div class="modal fade show custom_popup custom_popup_trade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl open-a-trade-class" role="document">
    <div class="modal-content trade-modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">
          {{ pageTitleSignal() }}
        </h5>

        <div *ngIf="!currentData?.acquisitionId" class="d-flex">
          <label for="type" class="form-title text-nowrap me-1" style="color: white">Type:</label>
          <div class="input-group">
            <select
              class="custom-form-select border-radius-100"
              id="type"
              [(ngModel)]="selectedType"
              [ngModelOptions]="{ standalone: true }"
              (change)="onTypeChange($event)"
            >
              <option value="" disabled hidden>Select</option>
              <option *ngFor="let item of etrTypes" [value]="item.id">
                {{ item.fullName }}
              </option>
            </select>
          </div>
        </div>
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <ngx-spinner type="ball-scale-multiple"></ngx-spinner>

      <div class="modal-body padding-model form-editing">
        <div class="row">
          <div class="col-lg-12">
            <div class="card w-100 mb-0">
              <div class="card mb-0">
                <app-a-etr-trade
                  *ngIf="selectedType === 'a-ETR'"
                  [type]="selectedType"
                  [currentData]="currentData"
                  [isEditTrade]="isEditTrade"
                  (isCloseModal)="closeModal($event)"
                />
                <app-f-etr-trade
                  *ngIf="selectedType === 'f-ETR'"
                  [type]="selectedType"
                  [currentData]="currentData"
                  [isEditTrade]="isEditTrade"
                  (isCloseModal)="closeModal($event)"
                />
                <app-b-etr-trade
                  *ngIf="selectedType === 'b-ETR'"
                  [type]="selectedType"
                  [currentData]="currentData"
                  [isEditTrade]="isEditTrade"
                  (isCloseModal)="closeModal($event)"
                />
                <app-c-etr-trade
                  *ngIf="selectedType === 'c-ETR'"
                  [type]="selectedType"
                  [currentData]="currentData"
                  [isEditTrade]="isEditTrade"
                  (isCloseModal)="closeModal($event)"
                />
                <app-d-etr-trade
                  *ngIf="selectedType === 'd-ETR'"
                  [type]="selectedType"
                  [currentData]="currentData"
                  [isEditTrade]="isEditTrade"
                  (isCloseModal)="closeModal($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
